import React, { useCallback, useEffect, useMemo, useState } from 'react';
import * as RrbApi from '../../../api/RrbAPI';
import { PAGE_LENGTH } from '../../../common/constants';
import { handleApiError } from '../../../common/errorHandler';
import DataTable from '../../../components/DataTable';
import { PageBody } from '../../../components/SiteWrapper';
import { formatDateTime } from '../../../utils/DateFormat';
import PageHeaderActions from '../../../components/General/PageHeaderActions';

export default function RrbTable() {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedRrb, setSelectedRrb] = useState(null);
  const [allRrb, setAllRrb] = useState(null);

  const [filter, setFilter] = useState({
    _page: 1,
    _limit: 25,
    q: '',
    _sort: 'id',
    _order: 'asc',
    isDelete: null,
  });

  const initialState = {
    sortBy: [{ id: 'id', desc: false }],
    pageSize: filter._limit,
    pageIndex: 0,
  };

  const fetchRrb = useCallback(async () => {
    setIsLoading(true);
    try {
      await RrbApi.getAll(filter).then(({ data }) => {
        if (data?.records) {
          setRows(data?.records);
          setTotalRecords(data?.totalRecords);
          if (!allRrb) {
            setAllRrb(data?.records);
          }
        }
      });
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  }, [filter]);

  useEffect(() => {
    const getData = setTimeout(() => {
      fetchRrb();
    }, 100);
    return () => clearTimeout(getData);
  }, [filter]);
  const columns = useMemo(
    () => [
      {
        Header: 'RRB',
        accessor: 'rrb_full_name',
        className: 'text-nowrap',
        disableSortBy: true,
        width: '200',
        Cell: ({ row }) => {
          return `${row.original.name} ${row.original.city}` || '-';
        },
      },
      {
        Header: 'Admin',
        accessor: 'Users',
        className: 'text-nowrap',
        disableSortBy: true,
        width: '200',
        Cell: ({ value }) => {
          return value[0]
            ? `${value[0].first_name} ${value[0].last_name}`
            : 'N/A';
        },
      },
      {
        Header: 'Last Updated',
        accessor: 'updated_at',
        className: 'text-nowrap',
        disableSortBy: true,
        width: '200',
        Cell: ({ row }) => {
          const updateAt = formatDateTime(row.original.updated_at);
          return <span role='button'>{`${updateAt}`}</span>;
        },
      },
      {
        Header: 'Added',
        accessor: 'created_at',
        className: 'text-nowrap',
        disableSortBy: true,
        width: '200',
        Cell: ({ value }) => {
          const createdAt = formatDateTime(value);
          return <span role='button'>{`${createdAt} `}</span>;
        },
      },
    ],
    []
  );
  const extraSelectOptions =
    allRrb?.map((rrb) => ({
      key: rrb.id,
      label: rrb.rrb_full_name,
    })) ?? [];

  return (
    <PageBody>
      {/* <Card md="12" className='p-0'>
        <Card.Header className="bg-light-rrb">
          <h3 className="card-title fw-bold">Centers</h3>
        </Card.Header>
        <Card.Body className="p-0"> */}
      <DataTable
        header={<PageHeaderActions title='Recruitment Boards' />}
        columns={columns}
        data={rows}
        initialState={initialState}
        totalRecords={totalRecords}
        setFilter={setFilter}
        tableHooks={() => {}}
        defaultPageLength={[25, 50, 100]}
        extraSelectFilter={true}
        extraSelectOptions={extraSelectOptions}
        defaultOption={{ key: null, label: 'Select Recruitment Board' }}
        setSelectState={(id) => {
          setFilter((prev) => ({ ...prev, q: id }));
        }}
        isLoading={isLoading}
        manual={true}
        align='table-vcenter'
      />
      {/* </Card.Body>
      </Card > */}
    </PageBody>
  );
}
